<div class="res relative">
    <div class="link-all-tenders" *ngIf="singlePage==true"><button type="button" mat-mini-fab color="link" (click)="backToTenders()" title="חזרה לכל המכרזים"><mat-icon>arrow_back_ios</mat-icon></button></div>
    <div *ngIf="loading==true"><mat-spinner class="margin-auto"></mat-spinner></div>
    <div *ngIf="loadingFailed==true">חלה תקלה, נא נסו מאוחר יותר.</div>
    <div *ngIf="loading==false && loadingFailed==false">
    <div *ngIf="singlePage==true && expandInMobile==false">
        <div>
            <h2 class="middle-blue top-title">פרטי מכרז</h2>
        </div>
        <div class="tender-details">
            <div><label class="fs-15">שם מכרז: </label><b class="fs-20">{{tender.Title}}</b></div>
            <div><label class="fs-15">מספר מכרז: </label><b class="fs-20">{{tender.MolsaTenderNumber}}</b></div>
        </div>        
    </div>
    <div>
        <div class="linkTitle pointer mobile-col" (click)="expandTender($event)" *ngIf="singlePage==false" role="button" tabindex="0" (keyup.enter)="expandTender($event)" [attr.aria-expanded]="showMore">
            <div class="row flex-6 overflow-hidden">
                <div class="resImg flex-1"></div>
                <div class="linkTitleBold flex-10 flex-6-mobile overflow-hidden">
                    <div [ngClass]="{'ellipsis':showMore==false}">{{tender.Title}}</div>
                </div>
            </div>
            <div class="row flex-3">
                <label class="linkTitleLabel flex-1-3">מספר מכרז</label>
                <div class="linkTitleBold flex-1-7">{{tender.MolsaTenderNumber}}</div>
                <label class="linkTitleLabel flex-1">סטטוס</label>
                <div class="linkTitleBold middle-blue flex-1">{{tender.TenderStatus?tender.TenderStatus.TenderStatusDesc:''}}</div>
                <mat-icon class="flex-0-5 pointer" *ngIf="showMore==false">expand_more</mat-icon>
                <mat-icon class="flex-0-5 pointer" *ngIf="showMore==true">expand_less</mat-icon>
            </div>
        </div>
        <div>
            <div *ngIf="showMore==true || singlePage==true" class="show-more row" [@enterAnimation]>
                <div class="flex-15">
                    <div class="split" *ngIf="expandInMobile==false"></div>
                    <div class="row mobile-col">
                        <div class="flex-3">
                            <div class="tender-title-row" *ngIf="expandInMobile==true">
                                <div class="linkTitleLabel">שם המכרז</div>
                                <div class="tender-title middle-blue"><h2>{{tender.Title}}</h2></div>
                            </div>
                            <div class="props">
                                <div class="one-prop" *ngIf="expandInMobile==true">
                                    <div>מספר מכרז</div>
                                    <div><b>{{tender.MolsaTenderNumber}}</b></div>
                                </div>
                                <div class="one-prop" *ngIf="singlePage==true">
                                    <div>סטטוס</div>
                                    <div><b>{{tender.TenderStatus?tender.TenderStatus.TenderStatusDesc:''}}</b></div>
                                </div>
                                <div class="one-prop">
                                    <div>מועד פרסום</div>
                                    <div><b>{{getDdMmYyyy(tender.MolsaTenderPublishDate)}}</b></div>
                                </div>
                                <div class="one-prop">
                                    <div>מועד הגשה אחרון</div>
                                    <div><b>{{getDdMmYyyy(tender.MolsaProposalHandingDate)}}</b></div>
                                </div>
                                <div *ngIf="tender.MolsaTenderQADate" class="one-prop">
                                    <label>מועד אחרון לשאלות הבהרה</label>
                                    <div *ngIf="dateNotExpired(tender.MolsaTenderQADate)"><b>{{getDdMmYyyy(tender.MolsaTenderQADate)}}</b></div>
                                    <div *ngIf="!dateNotExpired(tender.MolsaTenderQADate)"><b>תם המועד</b></div>
                                </div>
                                <div *ngIf="tender.MolsaTenderUpdate" class="one-prop">
                                    <label>תאריך עדכון</label>
                                    <div><b>{{getDdMmYyyy(tender.MolsaTenderUpdate)}}</b></div>
                                </div>
                                <div *ngIf="tender.MolsaTenderPayment && tender.MolsaTenderPayment>0" class="one-prop">
                                    <label>סכום לתשלום</label>
                                    <div><b>{{tender.MolsaTenderPayment+' ש"ח'}}</b></div>
                                </div>
                            </div>
                            <div class="props">
                                <div class="flex-1" *ngIf="tender.MolsaTenderConventionLocation">
                                    <label>כנס ספקים</label>
                                    <div><label>מיקום: </label><b>{{tender.MolsaTenderConventionLocation}}</b></div>
                                    <div *ngIf="tender.MolsaTenderConventionDate && tender.MolsaTenderConventionDate!='0001-01-01T00:00:00Z'">
                                        <label>מועד: </label>
                                        <div class="ltr"><b>{{getDdMmYyyy(tender.MolsaTenderConventionDate)}}</b> <b>{{gethhmm(tender.MolsaTenderConventionDate)}}</b></div>
                                    </div>
                                </div>
                            </div>
                            <div class="props">
                                <div class="flex-1" *ngIf="tender.FullName || tender.EMail || tender.WorkPhone">
                                    <label>איש קשר</label>
                                    <div><b>{{tender.FullName}}</b></div>
                                    <div *ngIf="tender.EMail"><a [href]="'mailto:'+tender.EMail"><b>{{tender.EMail}}</b></a></div>
                                    <div *ngIf="tender.WorkPhone"><b>{{tender.WorkPhone}}</b></div>
                                </div>
                            </div>
                            <div class="props" *ngIf="tender.MolsaTenderMoreInfo">
                                <div>
                                    <div>מידע נוסף</div>
                                    <div class="note">
                                        <span [innerHTML]="tender.MolsaTenderMoreInfo"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex-1 col end space relative">
                            <!--<div [class]="'status-'+tender.MolsaTenderStatus">
                                <div>{{tender.TenderStatus?tender.TenderStatus.TenderStatusDesc:''}}</div>
                            </div>-->
                            <div class="left-links" *ngIf="showLinks">
                                <div class="row">
                                    <h3 class="title-15 middle-blue flex-0-5">קישורים</h3>
                                    <div class="only-mobile align-center flex-2-mobile">
                                        <div class="split-files"></div>
                                    </div>
                                </div>
                                <ul class="links hidden-ul">
                                    <li class="hidden-li left-link pointer" *ngIf="tender.TenderUrl">
                                        <mat-icon>launch</mat-icon>
                                        <a [href]="tender.TenderUrl" target="_blank">קישור למכרז במנהל הרכש הממשלתי</a>
                                    </li>
                                    <li class="hidden-li left-link" *ngIf="tender.MolsaTenderInManof">
                                        <mat-icon>launch</mat-icon>
                                        <!--<span [innerHTML]="getManofLink()"></span>-->
                                        <a [href]="tender.MolsaTenderInManof" target="_blank">קישור למנו"ף</a>
                                    </li>                                
                                    <li class="hidden-li left-link pointer" *ngIf="dateNotExpired(tender.MolsaProposalHandingDate)"><!-- (click)="openRegistration()">-->
                                        <mat-icon>edit</mat-icon> 
                                        <a [href]="registrationFormAddress" target="_blank">רישום לעדכונים</a>
                                        <!--<a [routerLink]="['/tenders/registration/'+tender.TenderId]" [state]="{tender:tender}">רישום לעדכונים</a>-->
                                        <!--<span>רישום לעדכונים</span>-->
                                    </li>
                                    <li class="hidden-li left-link pointer" *ngIf="tender.MolsaTenderQADate && dateNotExpired(tender.MolsaTenderQADate)"><!-- (click)="openQuestions()">-->
                                        <mat-icon>chat_icon</mat-icon>
                                        <a [routerLink]="['/questions/'+tender.TenderId]" [state]="{tender:tender}">שאלות הבהרה</a>
                                        <!--<span>שאלות הבהרה</span>-->
                                    </li>
                                    <li class="hidden-li left-link pointer" *ngIf="tender.MolsaTenderPayment && tender.MolsaTenderPayment>0 && dateNotExpired(tender.MolsaProposalHandingDate)">
                                        <mat-icon>shopping_cart</mat-icon>
                                        <span class="pointer" *ngIf="tender.MolsaTenderEncryptedPayment" (click)="pay()">תשלום</span>
                                        <div *ngIf="tender.MolsaTenderEncryptedPayment==''">ERROR!</div>
                                    </li>
                                    <li class="hidden-li left-link" *ngIf="showExpiredProposalHanding()">
                                        <a mat-flat-button class="review-payment-btn" [href]="expiredTenderPaymentUrl" target="_blank" rel="noopener">
                                            <span>תשלום לעיון בהצעות הזוכות</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="show-files">
                        <div class="row files-title">
                            <h3 class="flex-1 title-15 middle-blue">קבצים ונספחים</h3>
                            <div class="flex-6 align-center flex-2-mobile">
                                <div class="split-files"></div>
                            </div>
                        </div>
                        <div *ngIf="filesByType.length>0" class="wrap">
                            <div *ngFor="let ft of filesByType" class="prop files-group">
                                <label><b>{{ft.TenderFileTypeDesc}}:</b></label>
                                <ul class="files wrap hidden-ul">
                                    <li *ngFor="let f of ft.Files" class="hidden-li">
                                        <mat-icon>attach_file</mat-icon> 
                                        <a target="_blank" [href]="f.FileLink" [attr.aria-label]="getFileLabel(f)">{{f.FileName}}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div *ngIf="filesByType.length==0">לא נמצאו קבצים</div>
                    </div>
                </div>
                <div class="flex-0-5"></div>
            </div>
        </div>
    </div>
</div>
</div><!--one-res-->
